import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LayoutState {
  isAsideOpen: boolean;
}

const determineInitialState = (): boolean => {
  // Check the current path
  return window.location.pathname.endsWith('/detail'); // Open only for `/detail`
};

const initialLayoutState: LayoutState = {
  isAsideOpen: determineInitialState(),
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState: initialLayoutState,
  reducers: {
    toggleAside: (state) => {
      state.isAsideOpen = !state.isAsideOpen;
    },
    setAsideOpen: (state, action: PayloadAction<boolean>) => {
      state.isAsideOpen = action.payload;
    },
  },
});

export const { toggleAside, setAsideOpen } = layoutSlice.actions;
export default layoutSlice.reducer;
